import React, { Fragment, useEffect, useState } from 'react';
import { IconButton, Typography, Grid, Divider, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import ToastStr from '../../../request/toastStr';
import { COLORS } from '../../../shared/Theme';
import { SIcon } from '../../../shared/Icon';
import { DialogConfirm } from '../../../components/Dialog';
import { member as v_member, basic, Values, SNACKBAR_TIME } from '../../../request/values';
import useFixedButtonStyles from '../../../shared/commonStyles/headerEmpty/useFixedButtonStyles';

const SERVER = basic.server;

const useStyles = makeStyles((theme) => ({
	paper: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
	},
	title: {
		alignItems: 'left',
	},
	avatar: {
		margin: theme.spacing(1),
		backgroundColor: theme.palette.secondary.main,
	},
	form: {
		marginTop: '3vh',
		width: '82vw',
		[theme.breakpoints.up('md')]: {
			width: '100%',
		},
	},
	formWrapper: {
		width: '78vw',
		margin: 'auto',
		[theme.breakpoints.up('md')]: {
			width: '100%',
		},
	},
	desc: {
		fontFamily: 'NanumR',
		textAlign: 'center',
	},
	controlBar: {
		margin: 0,
		marginBottom: '1vh',
		paddingLeft: '3vw',
		paddingRight: '3vw',
	},
	statusButton: {
		marginBottom: '1vh',
		marginTop: '1vh',
		boxShadow: '6px 3px 6px 0 rgba(0, 0, 0, 0.16)',
		borderRadius: '10px',
		height: 'auto',
		backgroundColor: `${COLORS.WATER_BLUE}`,
	},
	status: {
		color: `${COLORS.WHITE}`,
		fontWeight: 'bold',
		textAlign: 'center',
		padding: '2vh',
	},
	standBy: {
		color: `${COLORS.DOWN}`,
		fontFamily: 'NanumR',
	},
	complete: {
		color: `${COLORS.WATER_BLUE}`,
		fontFamily: 'NanumB',
	},
	button: {
		height: 60,
		marginTop: '3vh',
		borderRadius: '27px',
		boxShadow: '6px 3px 6px 0 rgba(0, 0, 0, 0.16)',
		border: 'solid 0.5px #cfd4d9',
	},
	disable: {
		backgroundColor: `${COLORS.VERY_LIGHT_PINK}`,
	},
	able: {
		backgroundColor: `${COLORS.GREEN}`,
	},
	buttonSection: {
		width: '100%',
		marginTop: '7.5vh',
	},
	logoSection: {
		position: 'absolute',
		bottom: '5vh',
		left: 0,
		width: '100%',
		textAlign: 'center',
	},
	goBackButton: {
		height: 'auto',
		width: '50vw',
		textAlign: 'center',
		margin: 'auto',
		paddingTop: '0.5vh',
		borderRadius: '1.8vw',
		boxShadow: '6px 3px 6px 0 rgba(0, 0, 0, 0.16)',
		backgroundColor: `${COLORS.WHITE}`,
		[theme.breakpoints.up('md')]: {
			width: '70%',
		},
	},
	goBackButtonText: {
		color: `${COLORS.DOWN}`,
		fontFamily: 'NanumB',
		padding: '1vw',
	},
}));

type iCompany = {
	appCompanyNum: number;
	applicationDate: string;
	companyName: string;
	companyNum: number;
	companyType: string;
	grade: string;
};

const CompanyAppStandBy: React.FC<any> = (props) => {
	const classes = useStyles();
	const fixedButtonClasses = useFixedButtonStyles();
	const { t } = useTranslation('student');

	let history = useHistory();
	const { enqueueSnackbar, closeSnackbar } = useSnackbar();
	const { member, setMember } = props;

	const [company, setCompany] = useState<iCompany>();
	const [dialog, setDialog] = useState<boolean>(false);

	const getCompanyAppInfo = () => {
		console.log('in appstandby member,', member);
		let url = new URL(SERVER + v_member.member + v_member.company_app_info);
		let params = { email: member.id.toString() };
		url.search = new URLSearchParams(params).toString();

		axios({
			method: 'GET',
			withCredentials: true,
			url: url.toString(),
		})
			.then((res) => res.data)
			.then((data: any) => {
				console.log(data);
				if (data.code == Values.SUCCESS_CODE) {
					let company = data.companies;
					setCompany(data.companies);
					console.log(data.companies);
				} else if (data.code == Values.FAIL_CODE) {
					enqueueSnackbar(ToastStr.COMPANY_APP_INFO_FAIL_STR, {
						variant: 'warning',
						autoHideDuration: SNACKBAR_TIME,
					});
				} else {
					enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, {
						variant: 'error',
						autoHideDuration: SNACKBAR_TIME,
					});
				}
			});
	};
	useEffect(() => {
		getCompanyAppInfo();
		const tick = setInterval(() => {
			getCompanyAppInfo();
		}, 1000 * 5);
		return () => clearTimeout(tick);
	}, []);

	const handleClose = () => {
		setDialog((prevState) => !prevState);
	};

	const handleOpen = () => {
		if (!dialog) {
			setDialog((prevState) => !prevState);
		}
	};

	const handleStartButton = () => {
		if (company !== undefined && company.companyNum !== -1) {
			console.log(company!);
			console.log(company);
			setMember(
				Object.assign({}, member, {
					companyNum: company!.companyNum,
					companyType: company!.companyType,
				}),
			);

			history.push('/');
		}
	};

	const postDeleteCompanyApp = () => {
		axios({
			method: 'POST',
			data: {
				email: member.id,
				companyNum: company?.companyNum,
				// email: 'test5@test.com',
			},
			withCredentials: true,
			url: SERVER + v_member.member + v_member.company_app_del,
		})
			.then((res) => {
				return res.data;
			})
			.then((data: any) => {
				console.log(data);
				if (data.code == Values.SUCCESS_CODE) {
					setMember(Object.assign({}, member, { companyNum: 0 }));
					history.push({
						pathname: '/',
					});
				} else {
					if (data.code == Values.FAIL_CODE) {
						enqueueSnackbar(ToastStr.COMPANY_APP_DELETE_FAIL_STR, {
							variant: 'warning',
							autoHideDuration: SNACKBAR_TIME,
						});
					} else {
						enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, {
							variant: 'error',
							autoHideDuration: SNACKBAR_TIME,
						});
					}
				}
			});
		handleClose();
	};

	const goAppPage = () => {
		setMember(Object.assign({}, member, { companyNum: 0 }));
		history.push({
			pathname: '/CompanyProcess',
		});
	};

	if (company == null) {
		return (
			<div data-testid="company-app-stand-by-dashboard">
				<div className={fixedButtonClasses.fixedButton}>
					<IconButton onClick={goAppPage}>
						<SIcon type="Back" />
					</IconButton>
				</div>
				<div className={classes.paper}>
					<div className={classes.title}>
						<img src="/images/app_standBy.png" />
						<Typography variant="h1" className={classes.desc} style={{ fontFamily: 'NanumR' }}>
							{t('CompanyAppStandBy.reviewingTitle')}
						</Typography>
					</div>

					<div className={classes.form}>
						<div className={classes.formWrapper}>
							<Grid container justify="space-between" className={classes.controlBar}>
								<Grid>
									<Typography
										style={{
											fontSize: 20,
											fontWeight: 'bold',
											color: `${COLORS.CHARCOAL_GREY}`,
										}}
									>
										{t('CompanyAppStandBy.statusLabel')}
									</Typography>
								</Grid>
								<Grid>
									<IconButton onClick={getCompanyAppInfo} style={{ padding: 0 }}>
										<SIcon type="Refresh_Black" />
									</IconButton>
								</Grid>
							</Grid>
							<Divider />
							<div className={classes.statusButton}>
								<Typography variant="h2" className={clsx(classes.status)}>
									{t('CompanyAppStandBy.submitDoneWait')}
								</Typography>
							</div>

							<Divider />
						</div>
						<div className={classes.buttonSection}>
							<div onClick={goAppPage} className={classes.goBackButton}>
								<Typography variant="h2" className={classes.goBackButtonText}>
									{t('CompanyAppStandBy.goApplyAgain')}
								</Typography>
							</div>
						</div>
					</div>
				</div>
				<DialogConfirm
					open={dialog}
					handleClose={handleClose}
					title={t('companyProcess.applyCompany')}
					context={t('CompanyAppStandBy.cancelApplyConfirm')}
					yesConfirm={postDeleteCompanyApp}
					noConfirm={handleClose}
				/>
				<div className={classes.logoSection}>
					<SIcon type="P" />
				</div>
			</div>
		);
	} else {
		return (
			<div>
				<div className={fixedButtonClasses.fixedButton}>
					<IconButton onClick={() => handleOpen()}>
						<SIcon type="Back" />
					</IconButton>
				</div>
				<div className={classes.paper}>
					<div className={classes.title}>
						{company !== undefined && company.appCompanyNum > 0 && company.companyNum == null ? <img src="/images/app_standBy.png" /> : <img src="/images/app_complete.png" />}
						<Typography variant="h1" className={classes.desc} style={{ fontFamily: 'NanumR' }}>
							{company !== undefined &&
								company.companyName &&
								(company.appCompanyNum > 0 && company.companyNum == null ? (
									<span>{company.companyName + t('CompanyAppStandBy.companyReviewingMsg')}</span>
								) : (
									<span>{company.companyName + t('CompanyAppStandBy.companyAcceptedMsg')}</span>
								))}
						</Typography>
					</div>

					<div className={classes.form}>
						<div className={classes.formWrapper}>
							<Grid container justify="space-between" className={classes.controlBar}>
								<Grid>
									<Typography
										style={{
											fontSize: 20,
											fontWeight: 'bold',
											color: `${COLORS.CHARCOAL_GREY}`,
										}}
									>
										{t('CompanyAppStandBy.statusLabel')}
									</Typography>
								</Grid>
								<Grid>
									<IconButton onClick={getCompanyAppInfo} style={{ padding: 0 }}>
										<SIcon type="Refresh_Black" />
									</IconButton>
								</Grid>
							</Grid>
							<Divider />
							<Typography
								variant="h2"
								className={clsx(classes.status)}
								style={{
									color: company !== undefined && company.appCompanyNum > 0 && company.companyNum == null ? `${COLORS.DOWN}` : `${COLORS.WATER_BLUE}`,
								}}
								data-testid="company-app-stand-by-status"
							>
								{company !== undefined && company.appCompanyNum > 0 && company.companyNum == null ? t('CompanyAppStandBy.pending') : t('CompanyAppStandBy.approved')}
							</Typography>
							<Divider />
						</div>
						<div className={classes.buttonSection}>
							<Button
								fullWidth
								disabled={company !== undefined && company.appCompanyNum > 0 && company.companyNum == null ? true : false}
								className={clsx(classes.button, company !== undefined && company.appCompanyNum > 0 && company.companyNum == null ? classes.disable : classes.able)}
								onClick={handleStartButton}
								data-testid="company-app-stand-by-start-btn"
							>
								<Typography
									variant="h2"
									style={{
										color: `${COLORS.WHITE}`,
										fontFamily: 'NanumB',
										fontWeight: 'bold',
									}}
								>
									{t('CompanyAppStandBy.startPlayStartup')}
								</Typography>
							</Button>

							<div
								onClick={handleOpen}
								style={{
									textAlign: 'center',
									marginTop: '3.5vh',
								}}
							>
								<Typography
									variant="h2"
									style={{
										color: `${COLORS.DOWN}`,
										fontFamily: 'NanumB',
										fontWeight: 'bold',
									}}
								>
									{t('CompanyAppStandBy.cancelTogether')}
								</Typography>
							</div>
						</div>
					</div>
				</div>
				<DialogConfirm
					open={dialog}
					handleClose={handleClose}
					title={company !== undefined && company.companyName}
					context={t('CompanyAppStandBy.cancelApplyConfirm')}
					yesConfirm={postDeleteCompanyApp}
					noConfirm={handleClose}
				/>
				<div className={classes.logoSection}>
					<SIcon type="P" />
				</div>
			</div>
		);
	}
};

export default CompanyAppStandBy;
